import { html } from 'lit';
import { customElement } from 'lit/decorators.js';

import type { ExampleBasicContentObject } from './example-basic.model.js';
import { Constants } from './example-basic.constants.js';
import { PopBaseComponent } from '../../base/pop-base-component.js';

/**
 * A very basic example of extending the `PopBaseComponent` class
 * @tag pop-example-basic-component
 * @attribute {ExampleBasicContentObject} [data-component-object] ExampleBasic content object
 */
@customElement(Constants.TAG_NAME)
export class ExampleBasic extends PopBaseComponent {
  /**
   * @internal
   */
  tagName = Constants.TAG_NAME;

  /**
   * ExampleBasic content object
   */
  componentObject?: ExampleBasicContentObject;

  render() {
    return this.renderComponent(html`<p>${this.componentObject?.text}</p>`);
  }
}
